const ERROR_GUIDANCE = {
  DUPLICATE_DEMAND: {
    title: "मागणी आधीच तयार आहे",
    resolution: "कोणतीही कृती आवश्यक नाही. दुबार आकारणी टाळण्यासाठी ही नोंद सुरक्षितपणे वगळली आहे.",
  },
  ONE_TIME_ALREADY_ISSUED: {
    title: "एकदाच आकारला जाणारा कर आधीच जारी आहे",
    resolution: "कोणतीही कृती आवश्यक नाही. हा कर पुन्हा आकारता येत नाही.",
  },
  NO_APPROVED_RULE: {
    title: "मंजूर कर सूत्र उपलब्ध नाही",
    resolution: "कर सूत्रे विभागात या नोंद प्रकारासाठी लागू सूत्राची आवृत्ती तयार करून मंजूर करा.",
  },
  INVALID_BUSINESS_COMMENCEMENT: {
    title: "व्यवसाय सुरू झाल्याची तारीख उपलब्ध नाही",
    resolution: "व्यवसाय नोंद संपादित करून व्यवसाय सुरू झाल्याची वैध तारीख भरा आणि नोंद पुन्हा पडताळा.",
  },
  SUBJECT_NOT_ASSESSABLE: {
    title: "नोंद सक्रिय आणि पडताळलेली नाही",
    resolution: "मालमत्ता किंवा व्यवसाय नोंदीची स्थिती आणि पडताळणी पूर्ण करून नोंद सक्रिय करा.",
  },
  SUBJECT_NOT_FOUND: {
    title: "मूळ मालमत्ता किंवा व्यवसाय नोंद सापडली नाही",
    resolution: "कर खात्याशी जोडलेली मूळ नोंद तपासा. चुकीची जोडणी असल्यास योग्य नोंद निवडून खाते दुरुस्त करा.",
  },
  NO_PERIOD_LIABILITY: {
    title: "कर भरण्यास जबाबदार व्यक्ती जोडलेली नाही",
    resolution: "मालमत्तेचा मालक किंवा व्यवसायाचा कर-जवाबदार धारक नोंदीशी जोडा.",
  },
  INCOMPLETE_PERIOD_LIABILITY: {
    title: "कर-जवाबदार व्यक्तींची माहिती अपूर्ण आहे",
    resolution: "एक प्राथमिक जबाबदार व्यक्ती निवडा. संयुक्त मालकी असल्यास सर्व हिस्स्यांची बेरीज १००% ठेवा.",
  },
  AMBIGUOUS_PERIOD_LIABILITY: {
    title: "जबाबदार व्यक्तींच्या नोंदी परस्पर विसंगत आहेत",
    resolution: "मालकी किंवा व्यवसाय धारकांचा लागू कालावधी तपासून एकाच काळातील विसंगत नोंदी दुरुस्त करा.",
  },
  NO_PERIOD_BUSINESS_LOCATION: {
    title: "व्यवसायाचे सक्रिय ठिकाण उपलब्ध नाही",
    resolution: "व्यवसायामध्ये किमान एक सक्रिय प्राथमिक ठिकाण आणि त्याचा पूर्ण पत्ता नोंदवा.",
  },
  INCOMPLETE_PERIOD_BUSINESS_LOCATION: {
    title: "व्यवसायाचे प्राथमिक ठिकाण निश्चित नाही",
    resolution: "व्यवसायाच्या ठिकाणांपैकी नेमके एक ठिकाण प्राथमिक म्हणून निवडा.",
  },
  MISSING_INPUTS: {
    title: "कर गणनेसाठी आवश्यक माहिती अपूर्ण आहे",
    resolution: "सूत्राला आवश्यक मूल्यांकन, क्षेत्रफळ, उलाढाल किंवा इतर माहिती संबंधित नोंदीत भरा.",
  },
  INVALID_BILLING_PERIOD: {
    title: "सूत्राचा आकारणी कालावधी आर्थिक वर्षाशी जुळत नाही",
    resolution: "कर सूत्राचा आकारणी प्रकार वार्षिक करा किंवा त्या सूत्रासाठी योग्य स्वतंत्र प्रक्रिया वापरा.",
  },
  OVERLAPPING_RULE_VERSIONS: {
    title: "एकाच सूत्राच्या दोन आवृत्त्या लागू आहेत",
    resolution: "कर सूत्रांच्या लागू दिनांकांतील आच्छादन दुरुस्त करून एकच मंजूर आवृत्ती ठेवा.",
  },
  INVALID_DEMAND_REVISION_CHAIN: {
    title: "मागणीच्या सुधारणा इतिहासात विसंगती आहे",
    resolution: "संबंधित मागणीचा रद्द/सुधारणा इतिहास तपासून प्रलंबित विसंगती दुरुस्त करा.",
  },
  ACCOUNT_NOT_AVAILABLE: {
    title: "कर खाते उपलब्ध किंवा सक्रिय नाही",
    resolution: "मालमत्ता किंवा व्यवसायाचे कर खाते तपासून ते सक्रिय करा.",
  },
  CALCULATION_BLOCKED: {
    title: "कर गणना पूर्ण होऊ शकली नाही",
    resolution: "संबंधित नोंद आणि कर सूत्रातील आवश्यक माहिती तपासून प्रक्रिया पुन्हा चालवा.",
  },
};

const accountLookup = (accounts) =>
  new Map((accounts || []).map((account) => [String(account.account_uid), account]));

const ruleLookups = (rules) => {
  const byId = new Map();
  const byCode = new Map();
  const byVersion = new Map();
  (rules || []).forEach((rule) => {
    byId.set(String(rule.id), rule);
    if (rule.code) byCode.set(String(rule.code), rule);
    (rule.versions || []).forEach((version) => {
      byVersion.set(String(version.id), rule);
      if (version.version_uid) byVersion.set(String(version.version_uid), rule);
    });
  });
  return { byId, byCode, byVersion };
};

const subjectSummary = (account, subjectType) => {
  const subject = account?.subject || {};
  const type = account?.subject_type || subject.type || subjectType || "unknown";
  const fallback = type === "business" ? "व्यवसाय नोंद" : "मालमत्ता नोंद";
  const reference =
    subject.reference || subject.secondary_name || account?.account_number || "";
  const detail = [
    subject.address,
    subject.ward_number ? `प्रभाग ${subject.ward_number}` : "",
    subject.category,
  ]
    .filter(Boolean)
    .join(" · ");
  return {
    type,
    subjectUid: subject.uid || account?.subject_uid || null,
    name: subject.name || fallback,
    reference,
    detail,
  };
};

const emptyGroups = () => ({
  property: { newItems: [], skipped: [], errors: [] },
  business: { newItems: [], skipped: [], errors: [] },
  other: { newItems: [], skipped: [], errors: [] },
});

const groupForType = (type) =>
  type === "property" || type === "business" ? type : "other";

const INPUT_FIELD_LABELS = {
  assessed_value: "मालमत्तेचे आकारणी/भांडवली मूल्य",
  annual_rental_value: "वार्षिक भाडेमूल्य (ARV)",
  construction_type: "बांधकाम प्रकार",
  built_up_area_sqft: "बांधकाम क्षेत्रफळ",
  land_area_sqft: "जमीन क्षेत्रफळ",
  carpet_area_sqft: "कार्पेट क्षेत्रफळ",
  property_tax_applicable: "घरपट्टी लागू आहे का",
  water_tax_type: "पाणीपट्टी प्रकार",
  sanitary_tax_applicable: "स्वच्छता कर लागू आहे का",
  lighting_tax_applicable: "प्रकाश कर लागू आहे का",
  annual_turnover: "वार्षिक उलाढाल",
  employee_count: "कर्मचारी संख्या",
  employees_count: "कर्मचारी संख्या",
  business_type: "व्यवसाय प्रकार",
  business_category: "व्यवसाय श्रेणी",
  constitution_type: "व्यवसायाची कायदेशीर रचना",
  classification_code: "व्यवसाय वर्गीकरण कोड",
  license_type: "परवाना प्रकार",
  premise_area_sqft: "व्यवसाय जागेचे क्षेत्रफळ",
  signage_area_sqft: "फलकाचे क्षेत्रफळ",
};

const fieldLabel = field => INPUT_FIELD_LABELS[field] || String(field || "").replaceAll("_", " ");

export const assessmentGuidance = (code) =>
  ERROR_GUIDANCE[code] || {
    title: "नोंद तपासणे आवश्यक आहे",
    resolution: "संबंधित मालमत्ता, व्यवसाय आणि कर सूत्राची माहिती तपासून प्रक्रिया पुन्हा चालवा.",
  };

export const buildAnnualAssessmentView = (run, accounts, rules) => {
  const groups = emptyGroups();
  const accountsByUid = accountLookup([
    ...(accounts || []),
    ...(run?.subject_summaries || []),
  ]);
  const ruleMaps = ruleLookups(rules);
  const items = run?.rule_snapshot?.items || [];
  const exceptions = run?.exception_report || [];

  items.forEach((item) => {
    const account = accountsByUid.get(String(item.account_uid));
    const subject = subjectSummary(account, item.subject_type);
    const rule =
      ruleMaps.byId.get(String(item.rule_id)) ||
      ruleMaps.byCode.get(String(item.rule_code));
    groups[groupForType(subject.type)].newItems.push({
      ...subject,
      taxName: rule?.name_marathi || rule?.name || item.rule_code || "कर आकारणी",
      amount: Number(item.financials?.total_amount || 0),
    });
  });

  exceptions.forEach((entry) => {
    const account = accountsByUid.get(String(entry.account_uid));
    const subject = subjectSummary(account, entry.subject_type);
    const rule = ruleMaps.byVersion.get(String(entry.rule_version_id));
    const guidance = assessmentGuidance(entry.code);
    const missingFields = [...new Set(entry.details?.missing_fields || [])];
    const missingLabels = missingFields.map(fieldLabel);
    const actualResolution = missingLabels.length
      ? `या नोंदीमध्ये भरा: ${missingLabels.join(", ")}.`
      : entry.message || guidance.resolution;
    const normalized = {
      ...subject,
      code: entry.code,
      taxName: rule?.name_marathi || rule?.name || "",
      title: guidance.title,
      resolution: actualResolution,
      issueDetail: entry.message || "",
      missingFields: missingLabels,
      missingFieldKeys: missingFields,
      existingAmount: Number(entry.details?.existing_total_amount || 0),
      existingPaidAmount: Number(entry.details?.existing_paid_amount || 0),
      existingBalanceAmount: Number(entry.details?.existing_balance_amount || 0),
    };
    const bucket = entry.severity === "info" ? "skipped" : "errors";
    groups[groupForType(subject.type)][bucket].push(normalized);
  });

  return groups;
};
